<div class="busqueda-wrap">
  <div id="titulo">
    <h2>Siniestros Glass Talleres</h2>
    <h2 id="btnCerrar" mat-flat-button (click)="onClose()">X</h2>
  </div>
  <div id="tablaContainer">
    <table
      mat-table
      class="tabla-art"
      [class.modo-seleccion]="modoSeleccion"
      [class.modo-consulta]="!modoSeleccion"
      [dataSource]="dataSource"
      multiTemplateDataRows
    >
      <ng-container matColumnDef="arrow">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="col-arrow" (click)="toggleRow(element, $event)">
          <img
            class="arrow-icon"
            [src]="expandedElement === element ? 'assets/icons/flecha_expanded.svg' : 'assets/icons/flecha.svg'"
            [alt]="expandedElement === element ? 'Collapse' : 'Expand'"
            width="16"
            height="16"
          />
        </td>
      </ng-container>

      <ng-container *ngFor="let column of dataColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef>{{ columnLabels[column] }}</th>
        <td
          mat-cell
          *matCellDef="let element"
          (dblclick)="volcarSeleccion(element)"
        >{{ element[column] }}</td>
      </ng-container>

      <ng-container matColumnDef="accion">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="col-accion">
          <a
            class="btnCCOscuro"
            mat-flat-button
            (click)="seleccionarSiniestro(element, $event)"
          >Seleccionar</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" class="detail-cell" [attr.colspan]="displayedColumns.length">
          <div class="element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
            <div class="element-description" *ngIf="element === expandedElement">
              <mat-progress-bar *ngIf="cargandoDetalle" mode="indeterminate"></mat-progress-bar>
              <ng-container *ngIf="!cargandoDetalle">
                <table class="tabla-incidencia" *ngIf="detailData[getRowKey(element)]?.length; else sinIncidencia">
                  <colgroup>
                    <col class="col-id">
                    <col class="col-id-ralarsa">
                    <col class="col-estado">
                    <col class="col-incidencia">
                  </colgroup>
                  <thead>
                    <tr>
                      <th *ngFor="let column of displayedColumnsIncidencia">{{ columnLabelsIncidencia[column] }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of detailData[getRowKey(element)]">
                      <td *ngFor="let column of displayedColumnsIncidencia">{{ row[column] }}</td>
                    </tr>
                  </tbody>
                </table>
                <ng-template #sinIncidencia>
                  <table class="tabla-incidencia">
                    <tbody>
                      <tr>
                        <td class="sin-incidencia">Este siniestro no tiene registrado una incidencia.</td>
                      </tr>
                    </tbody>
                  </table>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let element; columns: displayedColumns;"
        class="element-row fila-seleccionable"
        [class.expanded-row]="!modoSeleccion && expandedElement === element"
        (click)="onFilaClick(element, $event)"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="detail-row"
        [class.detail-row-hidden]="modoSeleccion"
      ></tr>
    </table>
  </div>
  <mat-paginator [pageSizeOptions]="[5, 10]" [pageSize]="10" [length]="dataSource.data.length" [showFirstLastButtons]="true" (page)="onPageChange($event)"></mat-paginator>
</div>
